/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { createContext, useState,useEffect ,useContext, use, useMemo} from 'react';
import { IPickerModel, Me } from '@rhybus/api'
import { AuthContext } from './AuthContextProvider';
import { IDB_INQUIRY_LIST_STORE, ListNames, TRMRoles } from '../../shared/constants/globalConstants';
import { userRole } from '../../types/CommonTypes';
import { anewRListsHttp } from '../../shared/services/api/anew-r-lists-http';
import { authType, isProcessorDisabled, RHYBUS_ACCESS_TOKEN } from '../../Configuration';
import { DeviceDetailsContext } from './UserDeviceContextProvider';
import { constants } from 'buffer';
import { deleteIDB } from '../indexed-db/indexedDBHelper';
import { buildVersionChecker } from '../../global';


interface UserContextProviderProps {
  children: React.ReactNode;
}

// Initialize context with the default value
const UserInitalValue = 
{ 
     me: {} as Me,
     userRoles:{} as userRole,
     isUserDetailsLoading:true
};

const UserContext = createContext(UserInitalValue);
const type = authType.toLowerCase();
const UserContextProvider: React.FC<UserContextProviderProps> = ({ children }) => {
    const [me, setMe] = useState<Me>({} as Me);
    const[isUserDetailsLoading,setIsUserDetailsLoading]=useState(true)
    const [userRoles,setUserRoles] = useState<userRole>({
      isSiteAdmin:false,
      isTRMSales: false,
      isTRMInbound: false,
      isTRMOutbound: false,
      isTRMProcessor: false,
      isTRMAdmin: false,
      isTRMSuperAdmin:false,
      isCustomer:false,
      territories: [],
      inboundTerritories:[],
      outboundTerritories:[]
    })
    const {accessToken,getAccessToken}=use(AuthContext)
    const {isMobile,isWeb}=use(DeviceDetailsContext)
    useEffect(() => {
      const callme = async()=>{  
             if(!isWeb && isMobile && type === 'msal'){
               if(localStorage.getItem(RHYBUS_ACCESS_TOKEN) !== null ){
                  await doStart()
                }else{
                  await getAccessToken()
                  await doStart()
                }
              }else{
                   if(localStorage.getItem(RHYBUS_ACCESS_TOKEN) !== null && accessToken)
                  {
                      await doStart()
                  }else{
                    await getAccessToken()
                    await doStart()
                  } 
              }
    }
       callme()
   
  }
    , [AuthContext])

  async function doStart() {
  const meValue: Me = await anewRListsHttp().me();
  const userRolesFromAPI = meValue.roles || [];
  if(meValue?.userId){
  if (meValue?.userId) { 
    try { 
      await buildVersionChecker(); 
    } catch (e) { 
      console.error('Error checking build version:', e);
     } 
    }
  }
  const localStorageRoles = localStorage.getItem("userRoles");
  const localStorageUserID = localStorage.getItem("userID");
    if(localStorageRoles !== JSON.stringify(userRolesFromAPI) || localStorageUserID !== meValue.userId){
    await deleteIDB(IDB_INQUIRY_LIST_STORE)
    localStorage.setItem("userRoles", JSON.stringify(userRolesFromAPI));
    localStorage.setItem("userID", meValue.userId || "");
    }
 
  const TRMFlags: userRole = {
    isSiteAdmin: false,
    isTRMAdmin: false,
    isTRMInbound: false,
    isTRMOutbound: false,
    isTRMProcessor: false,
    isTRMSales: false,
    isTRMSuperAdmin:false,
    isCustomer:false,
    territories: [],
    inboundTerritories:[],
    outboundTerritories:[]
  };

  const roleMappings: Record<string, keyof Omit<userRole, 'territories'>> = {
  [TRMRoles.siteadmin]: "isSiteAdmin",
  [TRMRoles.admin]: "isTRMAdmin",
  [TRMRoles.superadmin]: "isTRMSuperAdmin",
  [TRMRoles.processor]: "isTRMProcessor",
  [TRMRoles.sales]: "isTRMSales",
};

  meValue?.roles?.forEach((role) => {
    const mappedFlag = roleMappings[role];
    if (mappedFlag) {
      TRMFlags[mappedFlag] = true;
      return;
    }

    const match = role.match(/^TRM\s+(.+?)\s+(Inbound|Outbound)$/i);
    if (match) {
      const territory = match[1].trim();
      const direction = match[2].trim();

      TRMFlags.territories.push(territory);

      if (direction === "Inbound") {
        TRMFlags.isTRMInbound = true;
        TRMFlags.inboundTerritories.push(territory);
      } else if (direction === "Outbound") {
        TRMFlags.isTRMOutbound = true;
        TRMFlags.outboundTerritories.push(territory);
      }
    }
  });
  if(isProcessorDisabled){
    TRMFlags.isTRMProcessor=false
  }
  if( !(TRMFlags.isTRMAdmin || TRMFlags.isTRMInbound || TRMFlags.isTRMOutbound || TRMFlags.isTRMProcessor || TRMFlags.isTRMSales || TRMFlags.isTRMSuperAdmin) ){
    TRMFlags.isCustomer=true
  }
  if(TRMFlags.isTRMSuperAdmin){
     TRMFlags.isTRMAdmin=true
  }
  setUserRoles(TRMFlags);
  setMe(meValue);
  setIsUserDetailsLoading(false)
}

  
  const contextValue = useMemo(() => ({ me, userRoles, isUserDetailsLoading }), [me, userRoles, isUserDetailsLoading])

  return (
    <UserContext.Provider value={contextValue}>
      {children}
    </UserContext.Provider>
  );
};

export { UserContext,UserContextProvider,UserInitalValue }